import generateUtilityClass from '@mui/utils/generateUtilityClass';
import generateUtilityClasses from '@mui/utils/generateUtilityClasses';
import composeClasses from '@mui/utils/composeClasses';
export function getChatStreamingIndicatorUtilityClass(slot) {
  return generateUtilityClass('MuiChatStreamingIndicator', slot);
}
export const chatStreamingIndicatorClasses = generateUtilityClasses('MuiChatStreamingIndicator', ['root', 'row', 'bubble']);
const slots = {
  root: ['root'],
  row: ['row'],
  bubble: ['bubble']
};
export const useChatStreamingIndicatorUtilityClasses = classes => composeClasses(slots, getChatStreamingIndicatorUtilityClass, classes);